import { BrandCaptionLowerThirdEntity, RoomId, roomId } from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomBrandCaptionLowerThirdDeleteResponseDTO {
  private static validation = JsonSchemaValidator.compile(
    RoomBrandCaptionLowerThirdDeleteResponseDTO.validationSchema(),
    BrandCaptionLowerThirdEntity
  );

  constructor(readonly data: RoomBrandCaptionLowerThirdDeleteResponse) {
    JsonSchemaValidator.assert(
      RoomBrandCaptionLowerThirdDeleteResponseDTO.validation,
      data
    );
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["roomId", "caption"],
      properties: {
        roomId,
        caption: {
          instanceof: BrandCaptionLowerThirdEntity.name
        }
      },
      additionalProperties: false
    };
  }
}

interface RoomBrandCaptionLowerThirdDeleteResponse {
  roomId: RoomId;
  caption: BrandCaptionLowerThirdEntity;
}
